import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BONUSES_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>('bonusesEnabled', {
  factory: () => true
});
